<template>
  <div
    v-if="searchResult.isOpenSearchResultModal"
    class="search-modal-container"
  >
    <div class="search-modal-background" @click="closeModal"></div>
    <div v-if="!currentList.length" class="no-search-result-container">
      <div class="no-search-result-inner-container">
        <h2 class="search-count-title">청구 조합 결과</h2>
        <span>청구 조합 결과가 없습니다.</span>
        <span>새로운 조합으로 조회해 보세요.</span>
        <button @click="closeModal">확인</button>
      </div>
    </div>
    <div v-else class="search-result-container">
      <div class="search-result-header">
        <div>
          <span class="search-count-title">청구 조합 결과</span>
          <span class="search-count">{{
            !isHideThreeAcupuncture
              ? currentList.length
              : searchResult.searchResultCount
          }}</span>
        </div>
        <button @click="closeModal">
          <i class="ii-remove"></i>
        </button>
      </div>
      <div class="search-result-body">
        <SearchResultItem
          v-for="(item, idx) in currentList"
          :key="`${idx}`"
          :selected-list="selectedList"
          :item="item"
          @update-list="updateList"
        />
      </div>
      <div class="search-result-footer">
        <v-switch
          v-model="isHideThreeAcupuncture"
          inset
          :label="`침술 3종`"
          class="hide-acupuncture-toggle-button"
          :class="{
            'active-acupuncture-toggle-button': isHideThreeAcupuncture,
          }"
        ></v-switch>

        <div>
          <span>{{
            `${
              !isHideThreeAcupuncture
                ? currentList.length
                : searchResult.searchResultCount
            }개 중 `
          }}</span>
          <span>{{ `${selectedList.length}개` }}</span>
          <span>선택</span>
        </div>
        <button
          class="post-button"
          :class="{ 'active-post-button': selectedList.length }"
          @click="postCombination"
        >
          조합 담기
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import SearchResultItem from '@/components/ClaimCombination/SearchResultItem.vue';
import { format, getYear } from 'date-fns';
import { combinationApi } from '../../services/apis';
export default {
  name: 'claim-combination-search-result',
  components: {
    SearchResultItem,
  },
  props: {
    searchResult: {
      type: Object,
      required: true,
    },
    currentMenu: {
      type: String,
      required: true,
    },
    referenceDate: {
      type: Date,
      required: true,
    },
  },
  data() {
    return {
      selectedList: [],
      isHideThreeAcupuncture: true,
    };
  },
  computed: {
    referenceYear() {
      return getYear(this.referenceDate);
    },
    currentList() {
      const isHide = this.isHideThreeAcupuncture;
      if (isHide) {
        return this.searchResult.searchData;
      }
      return this.filteredList;
    },
    // 침술 3종이 제거된 리스트
    filteredList() {
      return this.searchResult.searchData.filter(item => {
        // MARK : 침술이 3종 들어간 경우.
        // 아래 상황의 경우에 3종으로 분류된다.
        // 1. 부가 침술이 사암/오행/체질이면서 특수 침술이 하나라도 포함된 경우
        if (
          item.acupunctureAdditional === '4' &&
          item.acupunctureSpecial.length > 0
        ) {
          return false;
        }
        // 2 경혈 침술을 선택했고 부가 침술이 사암/오행이 아니면서 특수 침술이 2개 이상 포함된 경우
        if (
          item.acupunctureGeneral &&
          item.acupunctureAdditional !== '4' &&
          item.acupunctureSpecial.length >= 2
        ) {
          return false;
        }

        if (item.acupunctureAdditional && item.acupunctureSpecial.length >= 2) {
          return false;
        }
        // 3. 부가 침술이 자락/도침/산침, 화침/온침이면서 특수 침술이 2개 이상 포함된 경우
        return true;
      });
    },
  },
  watch: {
    isHideThreeAcupuncture: {
      handler() {
        this.selectedList = [];
      },
      immediate: true,
    },
  },
  methods: {
    updateList(curList) {
      // 이미 리스트에 있다면 제거 아니면 추가
      const isExist = this.selectedList.some(item => {
        return item.id === curList.id;
      });
      if (isExist) {
        this.selectedList = this.selectedList.filter(item => {
          return item.id !== curList.id;
        });
      } else {
        this.selectedList.push(curList);
      }
    },
    async postCombination() {
      try {
        const isNotSelected = this.selectedList.length === 0;
        if (isNotSelected) {
          return;
        }
        const body = this.selectedList.map(v => {
          return {
            ...v,
            referenceDate: format(this.referenceDate, 'yyyy-MM-dd'),
          };
        });
        const { status } = await combinationApi.postCombination(body);
        if (status === 200 || status === 204) {
          this.$emit('update:currentMenu', '청구 바구니');
          this.closeModal();
        }
      } catch (e) {
        console.log(e);
      }
    },
    closeModal() {
      this.selectedList = [];
      this.$emit('update:searchResult', {
        ...this.searchResult,
        isOpenSearchResultModal: false,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.search-modal-container {
  position: fixed;
  top: 0;
  z-index: 11;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.search-modal-background {
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.4);
  width: 100%;
  height: 100%;
}
.search-count-title {
  font-size: 1.5rem;
  font-weight: 700;
}
.search-count {
  font-weight: 600;
  font-size: 1.5rem;
  color: #1d77ff;
  margin-left: 0.375rem;
}

.search-result-container {
  background: #f1f3f8;
  border-radius: 1.25rem;
  // max-width: 54.5rem;
  height: 44rem;
  margin: 2.5rem 0;
  z-index: 12;
  .search-result-header {
    display: flex;
    height: 4.5rem;
    align-items: center;
    justify-content: space-between;
    padding: 1.375rem 2.5rem;
    background-color: #fff;
    border-top-right-radius: 1.25rem;
    border-top-left-radius: 1.25rem;
    .ii-remove {
      font-size: 1.5rem;
    }
  }
  .search-result-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 1.25rem 1.5rem;
    overflow-y: scroll;
    overflow-x: hidden;
    height: calc(100% - (5.75rem + 4.5rem));
    -ms-overflow-style: none; /* 인터넷 익스플로러 */
    scrollbar-width: none; /* 파이어폭스 */
  }

  .search-result-footer {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 1.25rem 2rem;
    background-color: #fff;
    height: 5.75rem;
    box-shadow: 0px -1px 0px #e1e4ec;
    border-bottom-right-radius: 1.25rem;
    border-bottom-left-radius: 1.25rem;
    span:nth-child(2) {
      font-weight: 700;
    }
    .post-button,
    .active-post-button {
      width: 12.5rem;
      height: 3.25rem;
      border-radius: 0.375rem;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 1rem 0.875rem;
      margin-left: 1rem;
    }
    .post-button {
      background: #e1e4ec;
      color: #fff;
    }
    .active-post-button {
      background: #1d77ff;
      color: #fff;
    }
    .hide-acupuncture-toggle-button {
      position: absolute;
      left: 2rem;
    }
    .active-acupuncture-toggle-button::v-deep .v-input--switch__thumb {
      color: #fff !important;
    }
    .active-acupuncture-toggle-button ::v-deep .v-input--switch__track {
      color: #3eb75d !important;
      opacity: 1;
    }
  }
}
.no-search-result-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);

  .no-search-result-inner-container {
    display: flex;
    flex-direction: column;
    width: 24.5rem;
    z-index: 12;
    text-align: center;
    height: 15.375rem;
    padding: 1.5rem;
    border-radius: 0.625rem;
    background: #fff;
    & > h2 {
      margin-bottom: 1.25rem;
    }
    & > span {
      font-size: 0.9375rem;
      color: #b5b7bf;
    }
    & > button {
      margin-top: 2.5rem;
      font-weight: 700;
      width: 100%;
      height: 3.25rem;
      border-radius: 0.375rem;
      background: #1d77ff;
      color: #fff;
      font-size: 0.9375rem;
    }
  }
}

::v-deep .v-input__slot {
  display: flex;
  flex-direction: row-reverse;
  .v-label {
    font-size: 0.8125rem !important;
    color: #515257 !important;
    margin-right: 0.5rem;
  }
}
// ::v-deep .v-input__slot {

// }
</style>
